<template>
  <div>
    <h1>Credit withdrawals</h1>
    <table class="mt-10">
      <thead>
        <th>Business</th>
        <th>Amount</th>
        <th>Interest</th>
        <th>Repayment due/on</th>
        <th>Withdrawn on</th>
      </thead>
      <tbody>
        <tr
          v-for="creditWithdrawal in creditHistory.data"
          :key="creditWithdrawal.id"
        >
          <td>{{ creditWithdrawal.business.name }}</td>
          <td>
            {{
              formatMoney(
                creditWithdrawal.amount,
                creditWithdrawal.business.currency.code,
                creditWithdrawal.business.currency.factor
              )
            }}
            (
            {{
              formatMoney(
                creditWithdrawal.repaymentAmount,
                creditWithdrawal.business.currency.code,
                creditWithdrawal.business.currency.factor
              )
            }}
            )
          </td>
          <td>
            {{
              formatMoney(
                creditWithdrawal.interest,
                creditWithdrawal.business.currency.code,
                creditWithdrawal.business.currency.factor
              )
            }}
          </td>
          <td>
            <span v-if="!creditWithdrawal.repaid">{{
              creditWithdrawal.dueOn | moment("from")
            }}</span>
            <span v-else>
              Repaid ({{
                creditWithdrawal.repaidOn | moment("dddd, MMMM Do YYYY")
              }})
            </span>
          </td>
          <td>
            {{ creditWithdrawal.createdAt | moment("dddd, MMMM Do YYYY") }}
          </td>
        </tr>
      </tbody>
    </table>

    <el-pagination
      class="mt-10"
      :current-page="creditHistory.pagination.currentPage"
      layout="pager"
      :total="creditHistory.pagination.totalCount"
      @current-change="pageChanged"
      :page-size="100"
      hide-on-single-page
    />
  </div>
</template>

<script>
import PaginatedPage from "./PaginatedPage";
import { CREDIT_QUERY } from "@/api/queries";

export default {
  extends: PaginatedPage,
  apollo: {
    creditHistory: {
      query: CREDIT_QUERY,
      variables: {
        page: 1
      },
      result({ data }) {
        this.formatter = new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: data.creditHistory.data[0].business.currency.code
        });
      }
    }
  },
  data() {
    return {
      creditHistory: { data: [], pagination: { currentPage: 0, totalCount: 0 } }
    };
  },
  methods: {
    queryData(page) {
      this.$apollo.queries.creditHistory.refetch({ page });
    },
    formatMoney(amount, currency, factor) {
      const formatter = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency
      });
      return formatter.format(amount / factor);
    }
  }
};
</script>
